const heroBgCarouselManualEntry = {
  displayField: 'listingTitle',
  name: 'Hero Background Carousel - Manually Entered',
  description: '',
  fields: [
    {
      id: 'img',
      name: 'Image',
      type: 'Link',
      localized: false,
      required: false,
      validations: [ { linkContentType: [ 'imageWithFocalPoint' ] } ],
      disabled: false,
      omitted: false,
      linkType: 'Entry'
    },
    {
      id: 'listingTitle',
      name: 'Listing Title',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'price',
      name: 'Price',
      type: 'Integer',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'listingLink',
      name: 'ListingLink',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    }
  ],
  sys: {
    id: 'heroBgCarouselManualEntry',
    version: 4,
    updatedAt: '2023-08-01T21:35:37.248Z'
  }
};
export default heroBgCarouselManualEntry;